export default {
  common: {
    casino: "Jogos",
    more: "Mais",
    searchGames: "Buscar jogos",
    copied: "Copiado!",
    inputTooLong: "Entrada muito longa, por favor insira novamente.",
    inputNameCn: "Apenas caracteres chineses, letras, números e sublinhado são permitidos",
    inputCapital: "Apenas letras maiúsculas e sublinhado são permitidos",
    inputLowercaseUnderscore: "Apenas letras minúsculas e sublinhado são permitidos",
    inputLowercase: "Apenas letras minúsculas são permitidas",
    inputNoSpace: "Por favor, não insira apenas espaços",
    inputValidPhone: "Por favor, insira um número de telefone válido",
    inputNonNumber: "Contém caracteres não numéricos",
    inputNonLetter: "Contém caracteres que não são letras",
    inputLetterOrNumberOnly: "Apenas letras ou números são permitidos",
    phoneFormatError: "Formato de número de telefone inválido",
    inputLetterStartNumber: "Deve começar com uma letra e pode conter números",
    inputNoChinese: "Caracteres chineses não são permitidos",
    inputChineseOnly: "Apenas caracteres chineses são permitidos",
    emailFormatError: "Formato de e-mail inválido",
    urlFormatError: "Formato de URL inválido",
    jsonFormatError: "Formato JSON inválido",
    networkError: "Falha ao conectar ao servidor, tente novamente mais tarde.",
    siteUnavailable: "Este site está indisponível no momento, entre em contato com o administrador.",
    tokenExpired: "Sua sessão expirou, faça login novamente.",
    domainNotAuthorized: "Domínio não autorizado",
    demoEnvOnly: "Ambiente de demonstração, apenas para visualização",
    passwordLength630: "6-30 caracteres",
    newPasswordSameAsOld: "A nova senha não pode ser igual à senha antiga",
    confirmNewPassword: "Por favor, confirme sua nova senha",
    passwordsDoNotMatch: "As senhas não coincidem",
    withdrawPasswordChanged: "Senha de saque alterada com sucesso",
    withdrawPasswordSet: "Senha de saque definida com sucesso",
    withdrawPasswordSetFailed: "Falha ao definir a senha de saque",
    phoneDigitsOnly: "O número de telefone deve conter apenas dígitos",
    phoneTooShort: "Número de telefone muito curto (mín. {min} dígitos)",
    phoneTooLong: "Número de telefone muito longo (máx. {max} dígitos)",
    phoneInvalidPrefix: "Prefixo de número de telefone inválido",
    rolloverAll: "Todos os tipos",
    rolloverAllStats: "Todos os status",
    rolloverSuccessful: "Bem-sucedido",
    rolloverFailed: "Falhou",
    rolloverInProgress: "Em andamento",
    rolloverSuccess: "Sucesso",
    rolloverPending: "Pendente",
    rolloverCompleted: "Concluído",
    rolloverCancelled: "Cancelado",
    rolloverExpired: "Expirado",
    walletCash: "Dinheiro",
    walletBonus: "Bônus",
    sourceDeposit: "Depósito",
    sourceCommission: "Comissão",
    sourceManualAdd: "Adição manual",
    sourceManualSubtract: "Subtração manual",
  },
  redeemCode: {
    enterTip: "Digite seu código de resgate para reivindicar recompensas",
    placeholder: "Por favor, insira seu código",
    redeemBtn: "RESGATAR",
    pleaseEnterCode: "Por favor, insira seu código de resgate",
    redeemSuccess: "Resgate bem-sucedido!",
    redeemFailed: "Falha no resgate, tente novamente",
  },
};
